import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";

const CheckEnabledUser = ({ token, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const handleCheckEnabledUser = async () => {
    if (!token) {
      Swal.fire("Error", "Token tidak ditemukan", "error");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.get(
        "https://api.wifikamu.my.id/check-enabled-users",
        {
          headers: {
            Authorization: token,
          },
        }
      );

      await Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: res.data.message || "Proses dijalankan",
      });

      // Refresh parent SETELAH alert ditutup
      if (onSuccess) onSuccess();
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Gagal",
        text:
          err.response?.data?.message ||
          err.message ||
          "Terjadi kesalahan",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleCheckEnabledUser}
      disabled={loading}
      className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-60"
    >
      {loading ? "Processing..." : "Check Enabled User"}
    </button>
  );
};

export default CheckEnabledUser;
